import * as UiOutlinedInput from '@mui/material/OutlinedInput'
import React from 'react'

export type OutlinedInputProps = UiOutlinedInput.OutlinedInputProps

export function OutlinedInput({ ...props }: OutlinedInputProps) {
  return <UiOutlinedInput.default {...props} />
}
